import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keysobject'
})
export class KeysobjectPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    let obj = JSON.parse(value);
    let keys = [];
    for (let key in obj) {
      keys.push({key: key, value: obj[key]});
    }
    return keys;
  }

}
